import { getPlanLabel } from "./plans.js";

function formatMoney(amountCents, currency) {
  if (!amountCents || !currency) {
    return "";
  }

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amountCents / 100);
  } catch {
    return "";
  }
}

function formatDate(value) {
  if (!value) {
    return "";
  }

  try {
    const parts = new Intl.DateTimeFormat("en-ZA", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).formatToParts(new Date(value));
    const day = parts.find((part) => part.type === "day")?.value.replace(/^0+/, "") || "";
    const month = parts.find((part) => part.type === "month")?.value || "";
    const year = parts.find((part) => part.type === "year")?.value || "";
    if (!day || !month || !year) {
      return "";
    }
    return `${day} ${month} ${year}`;
  } catch {
    return "";
  }
}

export function formatSettingsDate(value) {
  return formatDate(value);
}

export function formatSettingsPlanSummary(plan = "free", subscription = null) {
  const planLabel = getPlanLabel(plan);
  const planCopy = `You're on the ${planLabel} plan.`;

  if (subscription?.cancelAtPeriodEnd) {
    const endDate = formatDate(subscription.currentPeriodEnd);
    return endDate
      ? `${planCopy} Your plan ends on ${endDate}.`
      : `${planCopy} No charge is currently scheduled.`;
  }

  const nextAmount = formatMoney(subscription?.priceAmountCents, subscription?.priceCurrency);
  const nextDate = formatDate(subscription?.currentPeriodEnd);
  if (nextAmount && nextDate) {
    return `${planCopy} Next bill: ${nextAmount} on ${nextDate}.`;
  }

  return `${planCopy} No charge is currently scheduled.`;
}
